module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("f2Qn3"))).then(() => parcelRequire('iQgoo'));